import { format, parseISO } from 'date-fns';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const RFQSentScreen = ({ rfqSentData }) => {
  const navigate = useNavigate();

  const { rfqData, submissionDeadline } = rfqSentData;
  const formattedSubmissionDeadline = submissionDeadline
    ? format(parseISO(submissionDeadline), 'dd MMMM yyyy')
    : '';

  return (
    <div className="bg-white rounded-lg font-roboto py-12 px-12 mx-6">
      {/* 🎉 Title */}
      <h2 className="text-4xl font-bold text-black flex items-center gap-2">
        <span className="text-4xl">🎉</span> Your RFQ Has Been Sent!
      </h2>
      <p className="mt-7 text-gray-600">
        Manufacturers will review your request and respond within the given
        deadline.
      </p>

      {/* RFQ Details */}
      <h3 className="mt-10 text-gray-600 font-medium mb-3 bg-gray-50 rounded px-2 py-1 text-lg">
        RFQ Details
      </h3>

      <div className="mt-4 mx-8 text-lg">
        <div className="grid grid-cols-7 text-gray-600 font-medium pb-2 mb-2">
          <span className="col-span-1">Quote No.</span>
          <span className="col-span-2">Company Name</span>
          <span className="col-span-1">Contact Person</span>
        </div>

        {rfqData.map((item, index) => (
          <div key={index} className="grid grid-cols-7 text-black gap-y-1 mb-1">
            <span className="col-span-1">{item.quoteNo}</span>
            <span className="col-span-2">{item.companyName}</span>
            <span className="col-span-1">{item.contactPerson}</span>
          </div>
        ))}
      </div>

      {/* Submission Deadline */}
      <div className="mt-12 rounded bg-gray-50 text-lg">
        <span className="text-gray-600 font-medium">Submission Deadline</span>
        <span className="ml-4 text-black font-medium">
          {formattedSubmissionDeadline}
        </span>
      </div>

      {/* Info Text */}
      <p className="mt-6 text-gray-700">
        You will receive updates as manufacturers respond.
      </p>

      {/* Button */}
      <div className="mt-8 flex justify-center">
        <button
          className="border border-lightPurple text-lightPurple px-4 py-2 rounded hover:bg-lightPurple hover:text-white transition duration-200"
          onClick={() => navigate('/buyer/dashboard')}
        >
          Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default RFQSentScreen;
